export default "__VITE_ASSET__FEuNxvGL__"